<div class="card001 {{ isOption ? 'options' : '' }} {{ isLogout ? 'logout' : '' }}" (click)="navigate()">
	<i class="card001__icon {{ iconCards }}"></i>
	<p class="card001__text">{{ nameCards }}</p>
</div>
